$(document).ready(function() {
    axios
        .get("/indicadores")
        .then(res => {
            let data = res.data;
            const formatter = new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
                minimumFractionDigits: 2
            });
            $(".indicadores")
                .find(".uf")
                .text(formatter.format(data.uf.valor));
            $(".indicadores")
                .find(".ipc")
                .text(data.ipc.valor);
            $(".indicadores")
                .find(".utm")
                .text(formatter.format(data.utm.valor));
            $(".indicadores")
                .find(".dolar")
                .text(formatter.format(data.dolar.valor));
            $(".indicadores")
                .find(".euro")
                .text(formatter.format(data.euro.valor));
            $(".indicadores").fadeIn();
        })
        .catch(err => console.error(err));
});
